import i18n from '@/locale';

const NF_FRAC_1 = {number_format: {fraction_digits: 1}};
const NF_PERCENT_2 = {number_format: {is_percent: true, fraction_digits: 2}};
const field_prefix = {
  '|avg': {tw: '平均', en: 'AVG. '},
  '|total': {tw: '總', en: 'Total '},
  '|pcount': {tw: '每次', en: 'Per Times '},
  '|pday': {tw: '每日', en: 'Daily '},
  '|puser': {tw: '每人', en: 'Per User'},
  '|pupd': {tw: '每人每日', en: 'PUPD. '},
  '|curr': {tw: '', en: ''},
  '|prev': {tw: '前期', en: 'PREV. '},
};

const field_suffix = {
  '|rank': {tw: '排名', en: ' RK.'},
  '|ratio': {tw: '佔比', en: ' %'},
  '|gr_amt': {tw: 'Δ', en: ' Δ'},
  '|gr_rate': {tw: 'Δ%', en: ' Δ%'},
};

//報表日期
const dimension_rpt_date = {
  'rpt_date': {
    name: {tw: '日期', en: 'date'},
    description: {tw: '報表資料所對應的日期', en: 'The date associated with the report data'},
    example: {
      tw: '例如查 7月1日 ~ 7月7日的報表，每一列的 rpt_date 會是 2026-07-01、2026-07-02 … 2026-07-07，代表那一天的所有指標。',
      en: 'For a report from Jul 1 to Jul 7, each row\'s rpt_date is 2026-07-01, 2026-07-02 … 2026-07-07, each representing that day\'s metrics.',
    },
  },
  'rpt_date_range_text': {
    name: {tw: '日期範圍', en: 'Date Range'},
    description: {tw: '報表查詢所選擇的起訖日期區間', en: 'The start and end date range selected for the report query'},
  },
};

//站台
const dimension_site = {
  'site_currency': {
    name: {tw: '市場', en: 'Market'},
    description: {tw: '網站所使用的幣別，用來區分不同市場', en: 'The currency used by the site, used to distinguish different markets'},
    example: {
      tw: '例如一個站用 TWD、另一個站用 USD，同樣是「儲值 10,000」在 TWD 市場是新台幣一萬元，在 USD 市場卻是美金一萬元，分析時務必先以 site_currency 分群再加總。',
      en: 'One site uses TWD and another uses USD; a "10,000 deposit" means TWD 10,000 on one and USD 10,000 on the other, so always split by site_currency before summing.',
    },
  },
  'site_group': {
    name: {tw: '群組', en: 'Group'},
    description: {tw: '網站所屬的營運群組分類', en: 'The operational group the site belongs to'},
  },
  'site_id': {
    name: {tw: '網站', en: 'Site'},
    description: {tw: '網站的唯一識別代碼', en: 'Unique identifier for the site'},
    example: {
      tw: '平台底下有兩個不同站點，各自有獨立的 site_id（例如 abc、xyz）',
      en: 'The platform has two different sites with separate site_ids (e.g., abc, xyz)',
    },
  },
  'site_name': {
    name: {tw: '網站名稱', en: 'Site Name'},
    description: {tw: '網站的顯示名稱', en: 'Display name of the site'},
  },
};

//遊戲
const dimension_game_common = {
  'game_brand_code': {
    name: {tw: '遊戲商', en: 'Game Brand'},
    description: {tw: '提供遊戲的廠商代碼', en: 'Game provider code'},
    example: {
      tw: '例如 PG、PP、JDB',
      en: 'e.g., PG, PP, JDB',
    },
  },
  'game_kind_code': {
    name: {tw: '遊戲種類', en: 'Game Kind'},
    description: {tw: '遊戲的分類代碼', en: 'Game kind code'},
  },
  'game_kind_name': {
    name: {tw: '遊戲種類', en: 'Game Kind'},
    description: {tw: '遊戲分類的顯示名稱', en: 'Display name of the game category'},
    example: {
      tw: '例如 Slots、Fishing、Card/Table',
      en: 'e.g., Slots, Fishing, Card/Table',
    },
  },
  'game_theme_id': {
    name: {tw: '遊戲ID', en: 'Game Theme ID'},
    description: {tw: '單一遊戲的唯一識別代碼', en: 'Unique identifier for an individual game'},
  },
  'game_theme_name': {
    name: {tw: '遊戲名稱', en: 'Game Theme Name'},
    description: {tw: '單一遊戲的顯示名稱', en: 'Display name of an individual game'},
  },
};

//活動
const dimension_promo_common = {
  'promo_type_id': {
    name: {tw: '活動類型', en: 'Promo Type'},
    description: {tw: '活動的大分類，包含綁定、抽獎、一般、其他', en: 'Main promo category: binding, lottery, general, or others'},
  },
  'promo_type_name': {
    name: {tw: '活動類型', en: 'Promo Type'},
    description: {tw: '活動大分類的顯示名稱', en: 'Display name of the main promo category'},
    example: {
      tw: '四種主要類型：「綁定」（儲值後要打滿倍數才能出金）、「抽獎」（轉盤/刮刮樂）、「一般」（首儲禮、每日簽到）、「其他」；不同類型的成本與 ROI 邏輯不一樣，需分開看。',
      en: 'Four main types: Binding (must wager N× before cashing out), Lottery (wheel/scratch), General (first-deposit gift, daily sign-in), Others; cost and ROI logic differ per type.',
    },
  },
  'promo_sub_type_id': {
    name: {tw: '活動子類型', en: 'Promo Sub Type'},
    description: {tw: '活動在大分類下的細項分類', en: 'Sub-category within the main promo type'},
  },
  'promo_tag_list': {
    name: {tw: '活動標籤', en: 'Promo Tags'},
    description: {tw: '活動所標記的標籤，用於快速篩選和歸類活動', en: 'Tags assigned to the promo for quick filtering and grouping'},
  },
  'promo_id': {
    name: {tw: '活動ID', en: 'Promo ID'},
    description: {tw: '單一活動的唯一識別代碼', en: 'Unique identifier for an individual promo'},
  },
  'promo_name': {
    name: {tw: '活動名稱', en: 'Promo Name'},
    description: {tw: '活動的顯示名稱', en: 'Display name of the promo'},
    example: {
      tw: '例如「新會員首儲 100% 送」、「週六存 500 送 100」；以此切分可比較各檔活動的吸客效果與成本。',
      en: 'Examples: "New Member 100% First-Deposit Bonus", "Saturday Deposit 500 Get 100"; slicing by this compares each promo\'s acquisition impact and cost.',
    },
  },
  'promo_date_start': {
    name: {tw: '活動開始日', en: 'Promo Start Date'},
    description: {tw: '活動開始生效的日期', en: 'The date the promo becomes active'},
  },
  'promo_date_end': {
    name: {tw: '活動結束日', en: 'Promo End Date'},
    description: {tw: '活動結束的日期，過期後玩家無法再參加', en: 'The date the promo expires; players can no longer join after this date'},
  },
  'promo_status': {
    name: {tw: '啟用狀態', en: 'Enabled'},
    description: {tw: '活動目前是否為啟用中，啟用才會對玩家生效', en: 'Whether the promo is currently active; only active promos take effect for players'},
  },
  'is_visible': {
    name: {tw: '前台是否顯示', en: 'Is Display on Frontend'},
    description: {tw: '活動是否在玩家端的頁面上顯示，隱藏的活動玩家看不到但仍可能生效', en: 'Whether the promo is visible to players on the frontend; hidden promos are not shown but may still be in effect'},
  },
};

//綁定型活動
const dimension_promo_binding = {
  'def_bonus_range': {
    name: {tw: '獎勵金額', en: 'Bonus Amount'},
    description: {tw: '綁定型活動設定的獎勵金額範圍，玩家參加後可獲得的贈金額度', en: 'Bonus amount range configured for the binding promo; the bonus a player receives upon joining'},
  },
  'def_bonus_rate': {
    name: {tw: '獎勵比例', en: 'Bonus Rate'},
    description: {tw: '綁定型活動依入金金額發放贈金的百分比', en: 'Percentage of the buy-in amount awarded as bonus in a binding promo'},
  },
  'def_buy_in_range': {
    name: {tw: '活動入金', en: 'Join Buy In'},
    description: {tw: '玩家參加綁定型活動時需要存入的金額範圍', en: 'Deposit amount range required for a player to join the binding promo'},
  },
  'def_pass_bet_rate': {
    name: {tw: '過關押分倍率', en: 'Pass Bet Rate'},
    description: {tw: '玩家需要達到的押分倍率才能過關解鎖提領，例如 30 倍表示需押滿入金的 30 倍', en: 'Turnover multiplier required to pass and unlock withdrawal, e.g. 30x means the player must wager 30 times the buy-in'},
  },
  'def_pass_net_win_range': {
    name: {tw: '解除活動餘額門檻', en: 'Promo Release Balance Threshold'},
    description: {tw: '玩家在活動中的餘額必須超出此範圍才可解除活動', en: 'Player balance must exceed this range during the promo to release the promo'},
  },
  'def_payout_max': {
    name: {tw: '最大提領額度', en: 'Max Payout'},
    description: {tw: '解除活動時，若玩家餘額超過此上限，超出部分將被系統回收', en: 'When releasing a promo, any balance exceeding this cap will be recovered by the system'},
  },
  'def_pre_dpst_amt_daily': {
    name: {tw: '當日累積存款', en: 'Daily DPST.'},
    description: {tw: '玩家當天累積的存款總額，部分活動會以此作為參加門檻', en: 'Player\'s total deposits for the day; some promos use this as an eligibility threshold'},
  },
  'def_pre_dpst_amt_total': {
    name: {tw: '迄今累積存款', en: 'Accumulated DPST.'},
    description: {tw: '玩家從註冊至今的累積存款總額，部分活動會以此作為參加門檻', en: 'Player\'s total deposits since registration; some promos use this as an eligibility threshold'},
  },
};

//道具
const dimension_game_item = {
  'game_item_type_id': {
    name: {tw: '道具類型', en: 'Game Item Type'},
    description: {tw: '道具卡的分類，不同類型的道具卡有不同的使用方式和獎勵機制', en: 'Category of the game item card; different types have different usage rules and reward mechanics'},
  },
  'game_item_def_item_bet': {
    name: {tw: '單張押分', en: 'Single Item Bet'},
    description: {
      tw: '使用一張道具卡所產生的總押分量，代表這張卡片的總投注價值。計算公式：轉數 × 單場押分',
      en: 'Total turnover generated by using one game item card, representing its total wagering value. Formula: Spin Count × Single Spin Bet',
    },
  },
  'game_item_def_spin_bet': {
    name: {tw: '單場押分', en: 'Single Spin Bet'},
    description: {
      tw: '道具卡每一場（轉）遊戲的押分金額，決定每次旋轉的投注大小',
      en: 'Bet amount per spin set by the game item card, determining the wager size for each round',
    },
  },
  'game_item_def_spin_count': {
    name: {tw: '轉數', en: 'Spin Count'},
    description: {
      tw: '一張道具卡可以使用的遊戲場次（旋轉次數），用完即消耗',
      en: 'Number of game rounds (spins) available on one game item card; consumed upon use',
    },
  },
  'game_item_def_win_multiple_avg': {
    name: {tw: '平均倍數', en: 'Avg Multiple'},
    description: {
      tw: '道具卡預期的平均中獎倍數，代表玩家平均每次遊戲能贏回押分的幾倍',
      en: 'Expected average win multiplier; indicates how many times the bet a player wins back on average per round',
    },
  },
  'game_item_def_win_multiple_max': {
    name: {tw: '最大倍數', en: 'Max Multiple'},
    description: {
      tw: '道具卡單次遊戲可能獲得的最高中獎倍數上限',
      en: 'Maximum win multiplier achievable in a single round with this game item card',
    },
  },
  'game_item_def_win_multiple_min': {
    name: {tw: '最小倍數', en: 'Min Multiple'},
    description: {
      tw: '道具卡單次遊戲保底的最低中獎倍數',
      en: 'Guaranteed minimum win multiplier per round for this game item card',
    },
  },
};

//三方
const dimension_tppp = {
  'tppp_code': {
    name: {tw: '三方', en: '3rd Party'},
    description: {tw: '第三方支付服務商的代碼，負責處理玩家的存提款交易', en: 'Third-party payment provider code, responsible for processing player deposit and withdrawal transactions'},
  },
  'tppp_method_code': {
    name: {tw: '支付方式', en: 'Pay Method'},
    description: {tw: '玩家使用的付款方式，例如銀行卡、電子錢包、QR Code等', en: 'Payment method used by the player, e.g. bank card, e-wallet, QR Code'},
  },
  'bank_code': {
    name: {tw: '銀行代碼', en: 'Bank Code'},
    description: {tw: '玩家進行存提款時使用的銀行通道代碼', en: 'Bank channel code used by the player for deposit/withdrawal transactions'},
  },
};

//網域
const dimension_network = {
  'full_domain': {
    name: {tw: '域名', en: 'Domain'},
    description: {tw: '玩家訪問網站時使用的完整網域名稱', en: 'Full domain name used by the player to access the site'},
  },
  'region_name': {
    name: {tw: '地區', en: 'Region'},
    description: {tw: '玩家所在的地理區域，根據 IP 位址判斷', en: 'Geographic region of the player, determined by IP address'},
  },
  'longitude': {
    name: {tw: '經度', en: 'Longitude'},
    description: {tw: '玩家地理位置的經度座標', en: 'Longitude coordinate of the player\'s location'},
  },
  'latitude': {
    name: {tw: '緯度', en: 'Latitude'},
    description: {tw: '玩家地理位置的緯度座標', en: 'Latitude coordinate of the player\'s location'},
  },
  'isp_name': {
    name: {tw: 'ISP', en: 'ISP'},
    description: {tw: '玩家使用的網路服務供應商名稱', en: 'Internet Service Provider used by the player'},
  },
  'os_name': {
    name: {tw: '作業系統', en: 'OS.'},
    description: {tw: '玩家裝置的作業系統，例如 Android、iOS、Windows', en: 'Operating system of the player\'s device, e.g. Android, iOS, Windows'},
  },
  'device_type': {
    name: {tw: '設備類型', en: 'Device Type'},
    description: {tw: '玩家使用的裝置類型，例如手機、平板、電腦', en: 'Type of device used by the player, e.g. mobile, tablet, desktop'},
  },
  'page_path': {
    name: {tw: '頁面路徑', en: 'Page Path'},
    description: {tw: '玩家瀏覽的網站頁面路徑，用於分析頁面流量分布', en: 'Page path visited by the player, used to analyze traffic distribution across pages'},
  },
};

//代理
const dimension_agent = {
  'agent_code': {
    name: {tw: '代理代碼', en: 'Agent Code'},
    description: {tw: '代理的層級代碼，以「0-12-345-」格式表示上下線關係', en: 'Hierarchical agent code in "0-12-345-" format, representing the upline-downline relationship'},
  },
  'agent_username': {
    name: {tw: '上級代理', en: 'Agent'},
    description: {tw: '該會員直屬的上級代理帳號', en: 'The direct upline agent account of this member'},
  },
  'channel_token': {
    name: {tw: '渠道', en: 'Channel'},
    description: {tw: '推廣渠道的識別碼，用於追蹤玩家是從哪個推廣管道進入', en: 'Promotional channel identifier, used to track which channel the player came from'},
  },
};

//客群
const dimension_member_segment = {
  'reg_date': {
    name: {tw: '註冊日', en: 'REG. Date'},
    description: {tw: '會員完成註冊的日期', en: 'The date the member completed registration'},
  },
  'reg_days_bucket_id': {
    name: {tw: '註冊天數', en: 'Registration Days'},
    description: {tw: '會員從註冊至今經過的天數區間，用於分析不同帳齡的會員行為', en: 'Days since registration bucket, used to analyze member behavior across different account ages'},
  },
  'reg_days_bucket_text': {
    name: {tw: '註冊天數', en: 'Registration Days'},
    description: {tw: '註冊天數區間的顯示文字', en: 'Display text for the registration days bucket'},
  },
  'last_gm_days_bucket_id': {
    name: {tw: '上次遊戲距離天數', en: 'Days Since Last Gaming'},
    description: {tw: '距離會員上一次玩遊戲已經過了多少天，天數越大代表越久沒回來玩', en: 'Number of days since the member last played; higher values indicate longer inactivity'},
  },
  'last_gm_days_bucket_text': {
    name: {tw: '上次遊戲距離天數', en: 'Days Since Last Gaming'},
    description: {tw: '上次遊戲距離天數區間的顯示文字', en: 'Display text for the days-since-last-gaming bucket'},
  },
  'dpst_amt_prank_bucket_id': {
    name: {tw: '排名(儲值量)', en: 'Rank Bucket'},
    description: {tw: '依會員累積儲值金額由高到低排名後的分組區間，用於識別高價值玩家', en: 'Rank bucket based on cumulative deposit amount (high to low), used to identify high-value players'},
  },
  'dpst_amt_prank_bucket_text': {
    name: {tw: '排名(儲值量)', en: 'Rank Bucket'},
    description: {tw: '儲值排名區間的顯示文字', en: 'Display text for the deposit rank bucket'},
  },
  'member_tag_code': {
    name: {tw: '會員標籤代碼', en: 'Member Tag Code'},
    description: {tw: '會員標籤的代碼，用於自定義分群管理', en: 'Tag code for custom member segmentation'},
  },
  'member_tag_id': {
    name: {tw: '會員標籤ID', en: 'Member Tag ID'},
    description: {tw: '會員標籤的唯一識別碼', en: 'Unique identifier for the member tag'},
  },
  'member_tag_list': {
    name: {tw: '會員標籤', en: 'Member Tags'},
    description: {tw: '會員身上所有標籤的列表，可用於篩選特定族群', en: 'List of all tags on the member, used to filter specific segments'},
  },
};

//會員等級
const dimension_member_level = {
  'member_lv_id': {
    name: {tw: '會員等級', en: 'Member Level'},
    description: {tw: '會員目前所在的 VIP 等級編號', en: 'The member\'s current VIP level ID'},
  },
  'member_lv_name': {
    name: {tw: '會員等級名稱', en: 'Member Level Name'},
    description: {tw: '會員 VIP 等級的顯示名稱', en: 'Display name of the member\'s VIP level'},
    example: {
      tw: '例如「一般會員 / 銀卡 / 金卡 / 鑽石」；以此切分可比較不同等級玩家的 ARPU 與留存差異，找出要重點經營的族群。',
      en: 'Examples: "Regular / Silver / Gold / Diamond"; slicing by this compares ARPU and retention across tiers to identify key segments.',
    },
  },
  'apv_bet_threshold': {
    name: {tw: '押分門檻', en: 'Turnover Threshold'},
    description: {tw: '升級到該等級所需的累積押分金額', en: 'Cumulative turnover required to reach this level'},
  },
  'apv_bet_threshold_diff': {
    name: {tw: '押分門檻級距', en: 'Turnover Threshold Diff'},
    description: {tw: '該等級與前一等級的押分門檻差距，代表從上一級升到這一級還需要多少押分', en: 'Turnover gap between this level and the previous one; how much more turnover is needed to upgrade'},
  },
  'dpst_amt_threshold': {
    name: {tw: '儲值門檻', en: 'Deposit Threshold'},
    description: {tw: '升級到該等級所需的累積儲值金額', en: 'Cumulative deposit amount required to reach this level'},
  },
  'dpst_amt_threshold_diff': {
    name: {tw: '儲值門檻級距', en: 'Deposit Threshold Diff'},
    description: {tw: '該等級與前一等級的儲值門檻差距，代表從上一級升到這一級還需要多少儲值', en: 'Deposit gap between this level and the previous one; how much more deposit is needed to upgrade'},
  },
  'dpst_count_threshold': {
    name: {tw: '儲值次數門檻', en: 'Deposit Count Threshold'},
    description: {tw: '升級到該等級所需的累積儲值次數', en: 'Cumulative number of deposits required to reach this level'},
  },
  'dpst_count_threshold_diff': {
    name: {tw: '儲值次數門檻級距', en: 'Deposit Count Threshold Diff'},
    description: {tw: '該等級與前一等級的儲值次數門檻差距，代表從上一級升到這一級還需要多少次儲值', en: 'Deposit count gap between this level and the previous one; how many more deposits are needed to upgrade'},
  },
};

//單一會員
const dimension_member_single = {
  'member_username': {
    name: {tw: '會員帳號', en: 'Member Username'},
    description: {tw: '會員用來登入的帳號名稱', en: 'The username the member uses to log in'},
  },
  'member_id': {
    name: {tw: '會員ID', en: 'Member ID'},
    description: {tw: '系統自動產生的會員唯一識別碼', en: 'System-generated unique identifier for the member'},
  },
  'member_type': {
    name: {tw: '會員類型', en: 'Member Type'},
    description: {tw: '會員的帳號類型分類，例如正式會員、測試帳號等', en: 'Account type classification, e.g. regular member, test account'},
  },
  'member_status': {
    name: {tw: '會員狀態', en: 'Member Status'},
    description: {tw: '會員帳號目前的狀態，例如正常、停用、凍結等', en: 'Current account status, e.g. active, disabled, frozen'},
  },
  'phone': {
    name: {tw: '電話', en: 'Phone'},
    description: {tw: '會員註冊時填寫的聯絡電話', en: 'Phone number provided by the member at registration'},
  },
  'email': {
    name: {tw: '信箱', en: 'Email'},
    description: {tw: '會員註冊時填寫的電子信箱', en: 'Email address provided by the member at registration'},
  },
  'real_name': {
    name: {tw: '真實姓名', en: 'Real Name'},
    description: {tw: '會員的真實姓名，通常用於提款身份驗證', en: 'Member\'s real name, typically used for withdrawal identity verification'},
  },
};

const dimension_definition = {
  ...dimension_rpt_date,
  ...dimension_site,
  ...dimension_game_common,
  ...dimension_promo_common,
  ...dimension_promo_binding,
  ...dimension_game_item,
  ...dimension_tppp,
  ...dimension_network,
  ...dimension_agent,
  ...dimension_member_segment,
  ...dimension_member_level,
  ...dimension_member_single,
};

//註冊
const metrics_register = {
  'reg_dau': {
    name: {tw: '註冊人數', en: 'REG. DAU.'},
    color_key: 'blue',
    description: {tw: '當天完成註冊的新會員人數，可觀察每日拉新成效', en: 'Number of new members who registered on the day; useful for tracking daily acquisition performance'},
    example: {
      tw: '某天有 300 位新訪客完成註冊，reg_dau = 300（即當天 300 人天）。reg_dau 是「人天」指標，跨天要加總；不過因為註冊一輩子只發生一次，整週 reg_dau 加總（例如 2,100 人天）剛好等於該週不重複新註冊人數 ── 這是 reg_dau 的特例，login_dau / gm_dau / dpst_dau 加總後只是人天，並不等於不重複人數。',
      en: 'If 300 new visitors complete registration on a day, reg_dau = 300 (i.e. 300 person-days that day). reg_dau is a person-day metric and accumulates across days; since registration only happens once per member, summing reg_dau across a week (e.g. 2,100 person-days) coincidentally equals the week\'s distinct new registrations — a special case. For login_dau / gm_dau / dpst_dau, the sum is just person-days, not unique users.',
    },
  },
};

//登入
const metrics_login = {
  'login_date_max': {
    name: {tw: '最後登入日', en: 'Last Login'},
    description: {tw: '會員最近一次成功登入的日期，距今越久代表越可能流失', en: 'Date of the member\'s most recent successful login; the longer ago, the higher the churn risk'},
  },
  'login_dau': {
    name: {tw: '登入DAU.', en: 'Login DAU.'},
    color_key: 'blue',
    description: {
      tw: '當天有成功登入的不重複會員人數，是衡量每日活躍度的基本指標',
      en: 'Number of unique members who logged in on the day; a fundamental measure of daily activity',
    },
    example: {
      tw: '某天有 5,000 人登入，其中 100 人登入了 3 次，login_dau 仍計為 5,000（即當天 5,000 人天）。login_dau 是「人天」單位 ── 阿明連續登入 7 天會被算成 7 人天，但他終究只是 1 個會員。一週 login_dau 加總（例如 35,000 人天）不是該週登入的不重複會員數；若只想看登入次數請用 login_count。',
      en: 'If 5,000 members logged in on a day, login_dau = 5,000 (i.e. 5,000 person-days that day) — counted once per member per day even if a member logged in 3 times. login_dau is a person-day measure: a member who logs in 7 days in a row contributes 7 person-days but is still only 1 unique member. Summing login_dau across a week (e.g. 35,000 person-days) is NOT the week\'s distinct logged-in users. For raw login attempts use login_count.',
    },
  },
  'login_hau': {
    name: {tw: '小時登入人數', en: 'Login HAU.'},
    color_key: 'blue',
    description: {
      tw: '該小時內有成功登入的不重複會員人數，可觀察尖峰時段的人流分布',
      en: 'Number of unique members who logged in during the hour; useful for observing peak traffic patterns',
    },
  },
  'login_count': {
    name: {tw: '登入次數', en: 'Login Count'},
    color_key: 'blue',
    description: {tw: '會員登入的總次數（含同一人多次登入），可觀察平台整體使用頻率', en: 'Total login attempts including repeat logins by the same member; indicates overall platform usage frequency'},
  },
};

//遊戲
const metrics_game_common = {
  'gm_date_max': {
    name: {tw: '最後遊戲日', en: 'Last Gaming'},
    description: {tw: '會員最近一次進行遊戲的日期，距今越久代表遊戲活躍度越低', en: 'Date of the member\'s most recent gaming session; the longer ago, the lower the gaming activity'},
  },
  'gm_days': {
    name: {tw: '遊戲天數', en: 'Gaming Days'},
    color_key: 'yellow',
    description: {tw: '會員在統計期間內有進行遊戲的天數，天數越多代表遊戲習慣越穩定', en: 'Number of days the member played games during the period; more days indicate a more consistent gaming habit'},
  },
  'gm_dau': {
    name: {tw: '遊戲DAU.', en: 'Game DAU.'},
    color_key: 'yellow',
    description: {
      tw: '當天有進行遊戲的不重複會員人數，是衡量遊戲參與度的核心指標',
      en: 'Number of unique members who played games on the day; a core metric for measuring gaming engagement',
    },
    example: {
      tw: '某天有 3,000 位會員玩過至少一場遊戲，不論阿明玩 50 把或小華玩 1 把都各算 1 人，gm_dau = 3,000（即當天 3,000 人天）。gm_dau 是「人天」單位 ── 阿明連玩一週貢獻 7 人天，但實際還是同一個人。把一週 gm_dau 加總（例如 21,000 人天）並不是該週的不重複玩家，要看區間不重複請用 gm_dist_users。',
      en: 'If 3,000 members played at least one round on a day, each counted once regardless of rounds played, gm_dau = 3,000 (i.e. 3,000 person-days that day). gm_dau is a person-day measure: a player who plays every day for a week contributes 7 person-days but is still 1 unique member. Summing gm_dau across the week (e.g. 21,000 person-days) is NOT the period\'s distinct players — use gm_dist_users for that.',
    },
  },
  'gm_hau': {
    name: {tw: '小時遊戲人數', en: 'Game HAU.'},
    color_key: 'yellow',
    description: {
      tw: '該小時內有進行遊戲的不重複會員人數，可觀察遊戲的尖峰時段',
      en: 'Number of unique members who played games during the hour; useful for identifying peak gaming hours',
    },
  },
  'gm_dist_users': {
    name: {tw: '不重複遊戲人數', en: 'Distinct Game Users'},
    color_key: 'yellow',
    description: {
      tw: '統計期間內至少玩過一次遊戲的不重複會員人數，不論玩了幾天都只算一人',
      en: 'Number of unique members who played at least once during the period, counted once regardless of how many days they played',
    },
  },
  'gm_count': {
    name: {tw: '遊戲場次', en: 'Gaming Count'},
    color_key: 'yellow',
    description: {
      tw: '所有會員參與遊戲的總回合數，場次越多代表整體遊戲活動量越大',
      en: 'Total number of game rounds played by all members; more rounds indicate higher overall gaming activity',
    },
    example: {
      tw: '某天 gm_dau = 3,000，gm_count = 600,000，代表平均每位玩家玩了 200 把；場次太低可能是遊戲體驗不佳或單場時間太長。',
      en: 'If gm_dau = 3,000 and gm_count = 600,000, each player averaged 200 rounds; low counts may indicate poor UX or overly long rounds.',
    },
  },
  'apv_bet': {
    name: {tw: '押分', en: 'Turnover'},
    color_key: 'yellow',
    description: {
      tw: '會員審核通過的總投注金額（又稱流水、有效投注），是衡量平台遊戲規模的最重要指標',
      en: 'Total approved bet amount (also known as turnover or valid bet); the most important metric for measuring the platform\'s gaming volume',
    },
  },
  'apv_bet_pcount': {
    name: {tw: '單把押分', en: 'Each Bet'},
    color_key: 'yellow',
    description: {
      tw: '玩家平均每一把遊戲投注的金額，數值越高代表玩家單次下注越大方',
      en: 'Average bet amount per round; higher values indicate players are wagering more per round',
    },
    example: {
      tw: '總押分 1,000,000 元、總場次 20,000 次，apv_bet_pcount = 50 元，代表平均每一把下注 50 元；若 VIP 玩家的單把是 500 元，一般玩家是 20 元，可據此設計差異化的 VIP 活動。',
      en: 'Total turnover 1,000,000 over 20,000 rounds gives apv_bet_pcount = 50; if VIPs average 500 per round vs 20 for regular players, use this to design tier-specific promos.',
    },
  },
  'house_net_win': {
    name: {tw: '網站營收', en: 'House Netwin'},
    color_key: 'yellow',
    description: {
      tw: '平台在遊戲中的淨收入，即玩家投注後扣除派彩的金額，正數代表平台賺、負數代表平台虧',
      en: 'Platform\'s net revenue from games (bets minus payouts); positive means the platform profits, negative means a loss',
    },
    example: {
      tw: '當天全站押分 1,000,000 元、派彩 970,000 元，house_net_win = 30,000 元；若某天押分大、house_net_win 卻是負數，代表玩家中大獎把莊家贏走，要觀察後續走勢。',
      en: 'With turnover 1,000,000 and payout 970,000, house_net_win = 30,000. A negative value on a high-turnover day means players hit big wins — watch the trend.',
    },
  },
  'play_net_win': {
    name: {tw: '玩家勝負', en: 'Player Netwin'},
    color_key: 'yellow',
    description: {
      tw: '玩家在遊戲中的淨輸贏，正數代表玩家整體是贏的、負數代表玩家整體是輸的。計算公式：網站營收 × -1',
      en: 'Players\' net win/loss in games; positive means players are winning overall, negative means losing. Formula: House Netwin × -1',
    },
    chart_type: 'candlestick',
  },
  'house_edge': {
    growth_kind: 'gr_amt',
    name: {tw: '莊家優勢', en: 'House Edge'},
    color_key: 'yellow',
    description: {
      tw: '平台在遊戲中平均能從玩家押分中賺取的比例，數值越高代表平台獲利能力越強。計算公式：網站營收 / 押分',
      en: 'Percentage of turnover the platform retains as profit on average; higher values indicate stronger profitability. Formula: House Netwin / Turnover',
    },
    example: {
      tw: '押分 1,000,000 元、house_net_win 30,000 元，house_edge = 3%；老虎機的理論 house_edge 通常落在 2%~6%，長期偏離太多要檢查資料或遊戲設定。',
      en: 'Turnover 1,000,000 and house_net_win 30,000 gives house_edge = 3%. Slots typically run at 2%–6%; sustained deviations warrant data or game-config checks.',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  // query_data 系列 rpt_crm_agent_game_daily / monthly 回的排名欄（每期各自 RANK() DESC，同值同名次）
  // growth_kind 為 gr_amt：配對兩期後得 later − early 的名次差，負數代表名次進步
  'gm_dau_rank': {
    name: {tw: '遊戲DAU.排名', en: 'Game DAU. RK.'},
    color_key: 'yellow',
    description: {tw: '依遊戲DAU.由高到低的名次，排名越前代表越多會員在玩', en: 'Rank by game DAU. in descending order; a higher rank means more members played'},
    growth_kind: 'gr_amt',
  },
  'apv_bet_rank': {
    name: {tw: '押分排名', en: 'Turnover RK.'},
    color_key: 'yellow',
    description: {tw: '依投注額由高到低的名次', en: 'Rank by approved bet amount in descending order'},
    growth_kind: 'gr_amt',
  },
  'house_net_win_rank': {
    name: {tw: '網站營收排名', en: 'House Netwin RK.'},
    color_key: 'yellow',
    description: {tw: '依莊家淨利由高到低的名次', en: 'Rank by house net win in descending order'},
    growth_kind: 'gr_amt',
  },
};

//存提
const metrics_trans = {
  'dpst_date_max': {
    name: {tw: '最後儲值日', en: 'Last DPST.'},
    description: {tw: '會員最近一次儲值的日期，距今越久可能代表玩家即將流失', en: 'Date of the member\'s most recent deposit; the longer ago, the higher the churn risk'},
  },
  'dpst_days': {
    name: {tw: '儲值天數', en: 'Deposit Days'},
    color_key: 'teal',
    description: {tw: '會員在統計期間內有進行儲值的天數，天數越多代表儲值習慣越穩定', en: 'Number of days the member deposited during the period; more days indicate a more consistent deposit habit'},
  },
  'dpst_dau': {
    name: {tw: '儲值DAU.', en: 'DPST. DAU.'},
    color_key: 'teal',
    description: {
      tw: '當天有進行儲值的不重複會員人數，是衡量每日付費活躍度的關鍵指標',
      en: 'Number of unique members who deposited on the day; a key metric for daily paying activity',
    },
    example: {
      tw: '某天有 900 位會員儲值，其中 50 人當天儲值 2 次以上，dpst_dau 仍計為 900（即當天 900 人天）。dpst_dau 是「人天」單位 ── 阿明連 7 天都儲值會貢獻 7 人天，但實際只是 1 位儲值會員。把一週 dpst_dau 加總（例如 6,300 人天）並不是該週的不重複儲值人數，要看區間不重複請用 dpst_dist_users。',
      en: 'If 900 members deposited on a day and 50 made multiple deposits, dpst_dau = 900 (i.e. 900 person-days that day). dpst_dau is a person-day measure: a member who deposits every day for a week contributes 7 person-days but is still 1 unique depositor. Summing dpst_dau across the week (e.g. 6,300 person-days) is NOT the period\'s distinct depositors — use dpst_dist_users for that.',
    },
  },
  'dpst_hau': {
    name: {tw: '小時儲值人數', en: 'DPST. HAU.'},
    color_key: 'teal',
    description: {
      tw: '該小時內有進行儲值的不重複會員人數，可觀察儲值的尖峰時段',
      en: 'Number of unique members who deposited during the hour; useful for identifying peak deposit hours',
    },
  },
  'dpst_dist_users': {
    name: {tw: '不重複儲值人數', en: 'Distinct DPST. Users'},
    color_key: 'teal',
    description: {
      tw: '統計期間內至少儲值過一次的不重複會員人數，不論儲了幾天都只算一人',
      en: 'Number of unique members who deposited at least once during the period, counted once regardless of frequency',
    },
  },
  'dpst_count': {
    name: {tw: '儲值次數', en: 'DPST. Count'},
    color_key: 'teal',
    description: {tw: '會員儲值的總次數（含同一人多次儲值），可觀察整體儲值頻率', en: 'Total number of deposits including repeat deposits by the same member; indicates overall deposit frequency'},
  },
  'dpst_amt': {
    name: {tw: '儲值', en: 'DPST.'},
    color_key: 'teal',
    description: {
      tw: '會員充值到平台帳戶的總金額，是衡量平台營收能力的核心指標',
      en: 'Total amount deposited into the platform by members; a core metric for measuring the platform\'s revenue capability',
    },
    example: {
      tw: '當天 dpst_amt = 500,000 元、dpst_dau = 100，平均每人儲值 5,000 元；此金額是玩家真的把錢打進平台的現金流，和 apv_bet（押分）是不同概念。',
      en: 'With dpst_amt = 500,000 and dpst_dau = 100, the average deposit per user is 5,000. This represents real cash inflow, unlike apv_bet which is wagering volume.',
    },
  },
  'wdrl_date_max': {
    name: {tw: '最後下分日', en: 'Last WDRL.'},
    description: {tw: '會員最近一次提款（下分）的日期', en: 'Date of the member\'s most recent withdrawal'},
  },
  'wdrl_dau': {
    name: {tw: '下分DAU.', en: 'WDRL. DAU.'},
    color_key: 'teal',
    description: {tw: '當天有進行提款的不重複會員人數', en: 'Number of unique members who made a withdrawal on the day'},
  },
  'wdrl_hau': {
    name: {tw: '小時下分人數', en: 'WDRL. HAU.'},
    color_key: 'teal',
    description: {tw: '該小時內有進行提款的不重複會員人數', en: 'Number of unique members who made a withdrawal during the hour'},
  },
  'wdrl_count': {
    name: {tw: '下分次數', en: 'WDRL. Count'},
    color_key: 'teal',
    description: {tw: '會員提款的總次數（含同一人多次提款）', en: 'Total number of withdrawals including repeat withdrawals by the same member'},
  },
  'wdrl_amt': {
    name: {tw: '下分', en: 'WDRL.'},
    color_key: 'teal',
    description: {
      tw: '會員從平台帳戶提領的總金額，提領金額過高需關注資金流出風險',
      en: 'Total amount withdrawn from the platform by members; excessively high withdrawals may signal cash-out risk',
    },
    example: {
      tw: '某天 dpst_amt = 500,000 元、wdrl_amt = 450,000 元，存提差只剩 50,000 元；若這種比例持續出現，代表玩家整體在贏錢，要檢查遊戲 RTP 或是否有打碼團。',
      en: 'If dpst_amt = 500,000 and wdrl_amt = 450,000, the deposit-withdrawal gap is only 50,000; sustained tight gaps suggest players are winning overall — check RTP or bonus-hunters.',
    },
  },
  'house_revenue': {
    name: {tw: '網站收益', en: 'House Revenue'},
    color_key: 'teal',
    description: {
      tw: '平台從存提差額中獲得的收益，正數代表平台淨流入、負數代表淨流出。計算公式：儲值 - 下分',
      en: 'Platform revenue from the deposit-withdrawal gap; positive means net inflow, negative means net outflow. Formula: Deposit - Withdrawal',
    },
  },
  'play_revenue': {
    name: {tw: '玩家收益', en: 'Player Revenue'},
    color_key: 'teal',
    description: {
      tw: '玩家從存提差額中獲得的收益，正數代表玩家整體是賺的。計算公式：下分 - 儲值',
      en: 'Player revenue from the deposit-withdrawal gap; positive means players are profiting overall. Formula: Withdrawal - Deposit',
    },
    chart_type: 'candlestick',
  },
  'house_revenue_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '網站收益率', en: 'House Revenue Rate'},
    color_key: 'teal',
    description: {
      tw: '平台收益佔儲值的比例，代表每收到 100 元儲值能留住多少。計算公式：網站收益 / 儲值',
      en: 'Platform revenue as a percentage of deposits; indicates how much of every 100 deposited is retained. Formula: House Revenue / Deposit',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'nature_dpst_amt_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '自然儲值率', en: 'Nature Deposit Rate'},
    color_key: 'teal',
    description: {
      tw: '不透過活動引導、由玩家主動儲值的金額佔總儲值的比例，數值越高代表玩家自發性越強、對活動依賴越低。計算公式：自然儲值 / 儲值',
      en: 'Proportion of deposits made voluntarily without promo incentives; higher values indicate stronger player initiative and less reliance on promos. Formula: Nature Deposit / Total Deposit',
    },
  },
};

//活動
const metrics_promo_common = {
  'bonus_dau': {
    name: {tw: '領取贈金人數', en: 'Bonus Claim DAU.'},
    color_key: 'pink',
    description: {
      tw: '當天有領取活動贈金的不重複會員人數，可觀察活動的參與熱度',
      en: 'Number of unique members who claimed promo bonuses on the day; indicates promo participation level',
    },
  },
  'bonus_amt': {
    name: {tw: '贈金', en: 'Bonus'},
    color_key: 'pink',
    description: {
      tw: '平台實際發出的淨贈金金額（已扣除回收部分），是活動的主要成本。計算公式：贈金發放 - 贈金回收',
      en: 'Net bonus amount distributed by the platform (after deducting returns); the primary cost of promotions. Formula: Bonus Out - Bonus Return',
    },
    example: {
      tw: '本月活動送出贈金 100,000 元，但有 20,000 元因玩家未達條件被系統回收，bonus_amt = 80,000 元；這 80,000 元才是真正吃進平台損益的活動成本。',
      en: 'A promo distributes 100,000 in bonuses but 20,000 is clawed back for unmet conditions; bonus_amt = 80,000, which is the real cost hitting the P&L.',
    },
  },
  'bonus_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '贈金率', en: 'Bonus Rate'},
    color_key: 'pink',
    description: {
      tw: '贈金成本佔押分的比例，比率越高代表活動成本越重。計算公式：贈金 / 押分',
      en: 'Bonus cost as a percentage of turnover; higher ratios indicate heavier promo costs. Formula: Bonus / Turnover',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'profit': {
    name: {tw: '利潤', en: 'Profit'},
    color_key: 'teal',
    description: {
      tw: '平台扣除活動成本後的淨利潤，是最終獲利的關鍵指標。計算公式：網站營收 - 贈金 + 系統回收',
      en: 'Platform net profit after deducting promo costs; the bottom-line profitability metric. Formula: House Netwin - Bonus + System Return',
    },
    example: {
      tw: '某月 house_net_win 300,000 元、bonus 80,000 元、系統回收 10,000 元，profit = 230,000 元；這才是真正能落袋的錢，遊戲贏多活動送更多會讓 profit 反而縮水。',
      en: 'With house_net_win 300,000, bonus 80,000, and system return 10,000, profit = 230,000 — the actual bottom line. Big game wins eaten up by bigger promo spend will shrink profit.',
    },
  },
  'profit_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '利率', en: 'Profit Rate'},
    color_key: 'teal',
    description: {tw: '利潤佔押分的比例，代表每 100 元押分最終能留下多少利潤', en: 'Profit as a percentage of turnover; indicates how much profit is retained per 100 in turnover'},
    example: {
      tw: '押分 10,000,000 元、profit 230,000 元，profit_rate = 2.3%；扣掉活動成本後才是真實獲利能力，通常比 house_edge 低一些。',
      en: 'Turnover 10,000,000 with profit 230,000 gives profit_rate = 2.3%; after promo costs, this is the true profitability — usually lower than house_edge.',
    },
  },
};

//道具
const metrics_game_item = {
  'game_item_add_count': {
    name: {tw: '道具發放數量', en: 'Game Item Add Count'},
    color_key: 'yellow',
    description: {tw: '平台發放給會員的道具卡總張數', en: 'Total number of game item cards distributed to members by the platform'},
  },
  'game_item_used_count': {
    name: {tw: '道具使用數量', en: 'Game Item Used Count'},
    color_key: 'yellow',
    description: {tw: '會員實際使用（消耗）的道具卡總張數', en: 'Total number of game item cards actually used (consumed) by members'},
  },
  'game_item_used_ratio': {
    growth_kind: 'gr_amt',
    name: {tw: '道具使用佔比', en: 'Game Item Used Ratio'},
    color_key: 'yellow',
    description: {
      tw: '已發放的道具中有多少被實際使用，比率越高代表道具的吸引力越強。計算公式：道具使用數量 / 道具發放數量',
      en: 'Proportion of distributed items that were actually used; higher ratios indicate more appealing items. Formula: Used Count / Add Count',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'game_item_bet': {
    name: {tw: '道具押分', en: 'Game Item Bet'},
    color_key: 'yellow',
    description: {
      tw: '會員使用道具卡進行遊戲後所產生的等值押分總量，代表道具帶動的遊戲投注規模',
      en: 'Total turnover generated from game item card usage, representing the wagering volume driven by items',
    },
  },
  'game_item_bonus': {
    name: {tw: '道具贈金', en: 'Game Item Bonus'},
    color_key: 'yellow',
    description: {
      tw: '會員使用道具卡遊戲後獲得的贈金總額，是道具活動的直接成本',
      en: 'Total bonus awarded from game item card usage; the direct cost of item-based promotions',
    },
  },
  'game_item_bonus_pcount': {
    name: {tw: '平均道具贈金', en: 'AVG. Game Item Bonus'},
    color_key: 'yellow',
    description: {
      tw: '平均每張道具卡被使用後產生的贈金，可評估單張道具的成本。計算公式：道具贈金 / 道具使用數量',
      en: 'Average bonus generated per item card used; useful for evaluating per-item cost. Formula: Game Item Bonus / Used Count',
    },
  },
  'game_item_rtp': {
    growth_kind: 'gr_amt',
    name: {tw: '道具RTP.', en: 'Game Item RTP.'},
    color_key: 'yellow',
    description: {
      tw: '道具的玩家回報率（Return To Player），代表玩家使用道具後能拿回多少比例的押分，數值越高對玩家越有利。計算公式：道具贈金 / 道具押分',
      en: 'Return To Player rate for game items; the percentage of item turnover returned to players as bonus. Higher values favor the player. Formula: Game Item Bonus / Game Item Bet',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'game_item_bonus_ratio': {
    growth_kind: 'gr_amt',
    name: {tw: '道具贈金率', en: 'Game Item Bonus Rate'},
    color_key: 'yellow',
    description: {
      tw: '該道具產生的贈金佔所有贈金的比例，用於比較不同道具的成本佔比。計算公式：道具贈金 / 該項目的總贈金',
      en: 'This item\'s bonus as a share of total bonus; useful for comparing cost contribution across different items. Formula: Game Item Bonus / Total Bonus',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'rpoint_add_amt': {
    name: {tw: '點數發放', en: 'Points Add'},
    color_key: 'light_purple',
    description: {
      tw: '平台發放給會員的獎勵點數總額，點數可用於兌換獎品或參加活動',
      en: 'Total reward points distributed to members; points can be redeemed for prizes or promo participation',
    },
  },
};

//綁定型活動
const metrics_promo_binding = {
  'join_count': {
    name: {tw: '參加次數', en: 'Join Count'},
    color_key: 'blue',
    description: {tw: '會員參加綁定型活動的總次數，次數越多代表活動參與度越高', en: 'Total number of times members joined binding promos; more joins indicate higher promo engagement'},
  },
  'pass_count': {
    name: {tw: '過關次數', en: 'Pass Count'},
    color_key: 'light_orange',
    description: {tw: '會員成功達成活動過關條件的次數，過關後才能提領獎勵', en: 'Number of times members successfully met the pass conditions; only after passing can rewards be withdrawn'},
  },
  'pass_ratio': {
    growth_kind: 'gr_amt',
    name: {tw: '過關率', en: 'Pass Ratio'},
    color_key: 'light_orange',
    description: {
      tw: '參加活動的會員中成功過關的比例，過關率太高可能代表活動門檻太低。計算公式：過關次數 / 參加次數',
      en: 'Percentage of participants who passed; an excessively high ratio may indicate the promo threshold is too low. Formula: Pass Count / Join Count',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'join_amt': {
    name: {tw: '活動入金', en: 'Buy In'},
    color_key: 'teal',
    description: {tw: '會員參加綁定型活動時存入的總金額', en: 'Total amount deposited by members when joining binding promos'},
  },
  'gain_amt': {
    name: {tw: '活動出金', en: 'Payout'},
    color_key: 'purple',
    description: {tw: '會員過關後從活動中提領的總金額', en: 'Total amount withdrawn by members after passing the promo'},
  },
  'promo_revenue': {
    name: {tw: '活動收益', en: 'Promo Revenue'},
    color_key: 'green',
    description: {
      tw: '平台在綁定型活動中的淨收益，正數代表平台從活動中賺錢。計算公式：活動入金 - 活動出金',
      en: 'Platform net revenue from binding promos; positive means the platform profits from the promo. Formula: Buy In - Payout',
    },
  },
  'bonus_out_amt': {
    name: {tw: '贈金發放', en: 'Bonus Out'},
    color_key: 'pink',
    description: {
      tw: '平台發放給會員的贈金總金額（尚未扣除回收部分），代表活動的總發放成本',
      en: 'Total bonus amount distributed to members (before any returns); represents the gross distribution cost of promotions',
    },
  },
  'bonus_19_amt': {
    name: {tw: '贈金回收', en: 'Bonus Return'},
    description: {tw: '因活動條件未達標或規則限制，從會員帳戶回收的贈金金額', en: 'Bonus amount recovered from member accounts due to unmet promo conditions or rule restrictions'},
  },
  'bonus_20_amt': {
    name: {tw: '系統回收', en: 'System Return'},
    color_key: 'light_gray',
    description: {
      tw: '綁定型活動中，玩家餘額超過系統設定的上限時，自動回收的贈金金額，用於控制活動成本',
      en: 'In bind-type promos, bonus automatically recovered when a player\'s balance exceeds the system-configured cap; used to control promo costs',
    },
  },
};

//註冊後轉化
const metrics_reg_cvt = {
  'reg_cvt_reg_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '註冊轉化%', en: 'Reg CVT %'},
    color_key: 'blue',
    description: {tw: '訪客成功完成註冊的比例，可觀察註冊流程的轉化效率', en: 'Percentage of visitors who completed registration; measures registration funnel efficiency'},
  },
  'reg_cvt_login_dau': {
    name: {tw: '登入轉化人數', en: 'Login CVT Users'},
    color_key: 'blue',
    description: {tw: '註冊後有再次登入的會員人數，代表新會員的回訪意願', en: 'Number of registered members who logged in again; indicates new member return intent'},
  },
  'reg_cvt_login_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '登入轉化%', en: 'Login CVT %'},
    color_key: 'blue',
    description: {tw: '註冊會員中有再次登入的比例，比率越低代表新會員流失越快', en: 'Percentage of registered members who returned to log in; lower rates indicate faster new member churn'},
    example: {
      tw: '某週註冊 1,000 人，之後只有 400 人再登入，reg_cvt_login_rate = 40%；比率過低通常是註冊流程體驗差、新手引導不到位或是假流量。',
      en: 'If 1,000 users registered in a week but only 400 logged in again, reg_cvt_login_rate = 40%; low rates often signal a poor signup UX, weak onboarding, or fake traffic.',
    },
  },
  'reg_cvt_game_dau': {
    name: {tw: '遊戲轉化人數', en: 'Gaming CVT Users'},
    color_key: 'blue',
    description: {
      tw: '註冊後有進行過遊戲的會員人數，代表新會員對遊戲的嘗試意願',
      en: 'Number of registered members who played games; indicates new members\' willingness to try games',
    },
  },
  'reg_cvt_game_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '遊戲轉化%', en: 'Gaming CVT %'},
    color_key: 'blue',
    description: {
      tw: '註冊會員中有進行遊戲的比例，是衡量新會員品質的重要指標。計算公式：遊戲轉化人數 / 註冊人數',
      en: 'Percentage of registered members who converted to gaming; a key metric for new member quality. Formula: Gaming CVT Users / Registered Users',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'reg_cvt_dpst_01_dau': {
    name: {tw: '首儲轉化人數', en: 'First DPST CVT Users'},
    color_key: 'blue',
    description: {
      tw: '註冊後完成首次儲值的會員人數，代表新會員願意掏錢的程度',
      en: 'Number of registered members who made their first deposit; indicates new members\' willingness to pay',
    },
  },
  'reg_cvt_dpst_01_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '首儲轉化%', en: 'First DPST CVT %'},
    color_key: 'blue',
    description: {
      tw: '註冊會員中完成首次儲值的比例，是衡量新會員付費轉化的核心指標。計算公式：首儲轉化人數 / 註冊人數',
      en: 'Percentage of registered members who made their first deposit; the core metric for new member payment conversion. Formula: First DPST CVT Users / Registered Users',
    },
    example: {
      tw: '註冊 1,000 人、首儲 80 人，reg_cvt_dpst_01_rate = 8%；這是判斷廣告素材與首儲活動效果的頭號指標，健康的水位通常落在 5%~15%。',
      en: 'With 1,000 registrations and 80 first deposits, reg_cvt_dpst_01_rate = 8%; the primary gauge for ad creative and first-deposit promos, usually healthy between 5% and 15%.',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'reg_cvt_dpst_02_dau': {
    name: {tw: '二儲轉化人數', en: 'Second DPST CVT Users'},
    color_key: 'blue',
    description: {tw: '註冊後完成第二次儲值的會員人數，代表首儲會員的回購意願', en: 'Number of registered members who made a second deposit; indicates first-depositors\' repurchase intent'},
  },
  'reg_cvt_dpst_02_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '二儲轉化%', en: 'Second DPST CVT %'},
    color_key: 'blue',
    description: {tw: '註冊會員中完成第二次儲值的比例，二儲率越高代表會員黏性越強', en: 'Percentage of registered members who made a second deposit; higher rates indicate stronger member stickiness'},
  },
};

//存款留存
const metrics_dpst_reten = {
  'dpst_reten_dau': {
    name: {tw: '儲值留存人數', en: 'DPST Retention DAU'},
    color_key: 'blue',
    description: {tw: '在指定留存天數後仍有回來儲值的會員人數', en: 'Number of members who returned to deposit after the specified retention period'},
  },
  'dpst_reten_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '儲值留存率', en: 'DPST Retention Rate'},
    color_key: 'blue',
    description: {tw: '首儲會員在指定天數後仍有回來儲值的比例，用於觀察付費會員的長期黏性', en: 'Percentage of first-depositors who returned to deposit after the specified number of days; measures long-term paying member stickiness'},
  },
  'dpst_reten_d00_dau': {
    name: {tw: '首儲人數', en: 'First DPST. DAU'},
    color_key: 'blue',
    description: {
      tw: '當天完成人生第一次儲值的會員人數，是留存率計算的基準母群',
      en: 'Number of members who made their very first deposit on the day; serves as the base cohort for retention rate calculations',
    },
  },
  'dpst_reten_d00_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '首儲留存率', en: 'First DPST. Reten Rate'},
    color_key: 'blue',
    description: {
      tw: '首儲會員在後續日期仍有回來儲值的比例。計算公式：儲值留存人數 / 首儲人數',
      en: 'Percentage of first-depositors who returned to deposit on subsequent days. Formula: DPST Retention DAU / First DPST DAU',
    },
  },
  'dpst_reten_d01_dau': {
    name: {tw: '1日儲值留存人數', en: 'D1 DPST. Reten DAU'},
    color_key: '91cc75',
    description: {
      tw: '首次儲值後隔天又回來儲值的會員人數，反映短期回購行為',
      en: 'Number of first-depositors who deposited again the next day; reflects short-term repurchase behavior',
    },
  },
  'dpst_reten_d01_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '1日儲值留存率', en: 'D1 DPST. Reten Rate'},
    color_key: '91cc75',
    description: {
      tw: '首儲會員隔天回來再儲值的比例，是觀察短期黏性的關鍵指標。計算公式：1日儲值留存人數 / 首儲人數',
      en: 'Percentage of first-depositors who deposited again the next day; a key metric for short-term stickiness. Formula: D1 DPST Reten DAU / First DPST DAU',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'dpst_reten_d03_dau': {
    name: {tw: '3日儲值留存人數', en: 'D3 DPST. Reten DAU'},
    color_key: 'fac858',
    description: {
      tw: '首次儲值後第 3 天回來儲值的會員人數',
      en: 'Number of first-depositors who deposited again on day 3',
    },
  },
  'dpst_reten_d03_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '3日儲值留存率', en: 'D3 DPST. Reten Rate'},
    color_key: 'fac858',
    description: {
      tw: '首儲會員第 3 天回來再儲值的比例。計算公式：3日儲值留存人數 / 首儲人數',
      en: 'Percentage of first-depositors who deposited again on day 3. Formula: D3 DPST Reten DAU / First DPST DAU',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'dpst_reten_d07_dau': {
    name: {tw: '7日儲值留存人數', en: 'D7 DPST. Reten DAU'},
    color_key: 'fc8452',
    description: {
      tw: '首次儲值後第 7 天回來儲值的會員人數',
      en: 'Number of first-depositors who deposited again on day 7',
    },
  },
  'dpst_reten_d07_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '7日儲值留存率', en: 'D7 DPST. Reten Rate'},
    color_key: 'fc8452',
    description: {
      tw: '首儲會員第 7 天回來再儲值的比例，是觀察中期黏性的重要指標。計算公式：7日儲值留存人數 / 首儲人數',
      en: 'Percentage of first-depositors who deposited again on day 7; an important metric for mid-term stickiness. Formula: D7 DPST Reten DAU / First DPST DAU',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'dpst_reten_d14_dau': {
    name: {tw: '14日儲值留存人數', en: 'D14 DPST. Reten DAU'},
    color_key: '9a60b4',
    description: {
      tw: '首次儲值後第 14 天回來儲值的會員人數',
      en: 'Number of first-depositors who deposited again on day 14',
    },
  },
  'dpst_reten_d14_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '14日儲值留存率', en: 'D14 DPST. Reten Rate'},
    color_key: '9a60b4',
    description: {
      tw: '首儲會員第 14 天回來再儲值的比例，用於評估會員的長期付費留存。計算公式：14日儲值留存人數 / 首儲人數',
      en: 'Percentage of first-depositors who deposited again on day 14; measures long-term paying retention. Formula: D14 DPST Reten DAU / First DPST DAU',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'dpst_stk': {
    growth_kind: 'gr_amt',
    name: {tw: '儲值黏著度', en: 'DPST. STK.'},
    color_key: 'teal',
    description: {
      tw: '會員在其活躍期間內有多頻繁儲值，數值越接近 1 代表幾乎每天都有儲值。計算公式：儲值天數 / 生命週期',
      en: 'How frequently a member deposited during their active period; closer to 1 means depositing nearly every day. Formula: Deposit Days / Life Days',
    },
  },
};

//遊戲留存
const metrics_gm_reten = {
  'gm_reten_d00_dau': {
    name: {tw: '新遊玩人數', en: 'New Gaming Users'},
    color_key: 'blue',
    description: {tw: '當天首次進行遊戲的會員人數，是遊戲留存率計算的基準母群', en: 'Number of members who played a game for the first time on the day; serves as the base cohort for gaming retention calculations'},
  },
  'gm_reten_d00_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '新遊玩留存率', en: 'New Gaming Retention Rate'},
    color_key: 'blue',
    description: {tw: '首次遊玩的會員在後續日期仍有回來玩遊戲的比例', en: 'Percentage of first-time players who returned to play on subsequent days'},
  },
  'gm_reten_d01_dau': {
    name: {tw: '隔日遊戲留存人數', en: 'Day 1 Retention DAU'},
    color_key: '91cc75',
    description: {tw: '首次遊玩後隔天又回來玩遊戲的會員人數，反映遊戲的短期吸引力', en: 'Number of first-time players who returned to play the next day; reflects the game\'s short-term appeal'},
  },
  'gm_reten_d03_dau': {
    name: {tw: '3日遊戲留存人數', en: 'Day 3 Retention DAU'},
    color_key: 'fac858',
    description: {tw: '首次遊玩後第 3 天回來玩遊戲的會員人數', en: 'Number of first-time players who returned to play on day 3'},
  },
  'gm_reten_d07_dau': {
    name: {tw: '7日遊戲留存人數', en: 'Day 7 Retention DAU'},
    color_key: 'fc8452',
    description: {tw: '首次遊玩後第 7 天回來玩遊戲的會員人數', en: 'Number of first-time players who returned to play on day 7'},
  },
  'gm_reten_d14_dau': {
    name: {tw: '14日遊戲留存人數', en: 'Day 14 Retention DAU'},
    color_key: '9a60b4',
    description: {tw: '首次遊玩後第 14 天回來玩遊戲的會員人數', en: 'Number of first-time players who returned to play on day 14'},
  },
  'gm_reten_d01_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '隔日遊戲留存率', en: 'Day 1 Retention Rate'},
    color_key: '91cc75',
    description: {tw: '首次遊玩的會員隔天回來玩的比例，是遊戲品質的重要指標', en: 'Percentage of first-time players who returned the next day; a key indicator of game quality'},
    example: {
      tw: '某週有 500 位新玩家第一次遊戲，其中 200 位隔天又回來玩，gm_reten_d01_rate = 40%；手遊業界常以 D1 留存 > 30% 為健康門檻。',
      en: 'If 500 new players played for the first time and 200 returned the next day, gm_reten_d01_rate = 40%; mobile gaming typically considers D1 retention > 30% healthy.',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'gm_reten_d03_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '3日遊戲留存率', en: 'Day 3 Retention Rate'},
    color_key: 'fac858',
    description: {tw: '首次遊玩的會員第 3 天回來玩的比例', en: 'Percentage of first-time players who returned on day 3'},
    example: {
      tw: '500 位新玩家中，第 3 天有 120 人回來，gm_reten_d03_rate = 24%；D3 通常比 D1 再掉 30%~50%，若掉幅過大表示玩家很快就發現遊戲不合口味。',
      en: 'Of 500 new players, 120 returned on day 3 for gm_reten_d03_rate = 24%; D3 typically drops 30%–50% from D1 — a steeper drop suggests players quickly lose interest.',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'gm_reten_d07_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '7日遊戲留存率', en: 'Day 7 Retention Rate'},
    color_key: 'fc8452',
    description: {tw: '首次遊玩的會員第 7 天回來玩的比例，用於評估遊戲的中期留存能力', en: 'Percentage of first-time players who returned on day 7; measures mid-term game retention'},
    example: {
      tw: '500 位新玩家中，第 7 天有 75 人回來，gm_reten_d07_rate = 15%；D7 是評估「這個玩家是否會變成長期用戶」的關鍵門檻。',
      en: 'Of 500 new players, 75 returned on day 7 for gm_reten_d07_rate = 15%; D7 is the key gate for assessing long-term user potential.',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'gm_reten_d14_rate': {
    growth_kind: 'gr_amt',
    name: {tw: '14日遊戲留存率', en: 'Day 14 Retention Rate'},
    color_key: '9a60b4',
    description: {tw: '首次遊玩的會員第 14 天回來玩的比例，用於評估遊戲的長期黏性', en: 'Percentage of first-time players who returned on day 14; measures long-term game stickiness'},
    example: {
      tw: '500 位新玩家中，第 14 天有 40 人回來，gm_reten_d14_rate = 8%；能撐到 D14 的玩家通常會變成穩定的付費用戶，是 LTV 的核心來源。',
      en: 'Of 500 new players, 40 returned on day 14 for gm_reten_d14_rate = 8%; players retained through D14 typically become stable paying users and a core LTV source.',
    },
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'gm_stickiness': {
    growth_kind: 'gr_amt',
    name: {tw: '遊戲黏著度', en: 'Gaming STK.'},
    color_key: 'yellow',
    description: {
      tw: '實際遊戲人數與預估遊戲人數的比率，數值越高代表遊戲的黏性越強、玩家回訪率越好。計算公式：實際遊戲 DAU / 預估遊戲 DAU',
      en: 'Ratio of actual to estimated gaming users; higher values indicate stronger game stickiness and better player return rates. Formula: Actual Gaming DAU / Estimated Gaming DAU',
    },
  },
  'gm_stk': {
    growth_kind: 'gr_amt',
    name: {tw: '遊戲黏著度', en: 'Gaming STK.'},
    color_key: 'yellow',
    description: {
      tw: '會員在其活躍期間內有多頻繁玩遊戲，數值越接近 1 代表幾乎每天都有玩。計算公式：遊戲天數 / 生命週期',
      en: 'How frequently a member played games during their active period; closer to 1 means playing nearly every day. Formula: Gaming Days / Life Days',
    },
  },
};

//三方存提
const metrics_tppp = {
  'dpst_create_count': {
    name: {tw: '[上分] 申請次數', en: '[DPST.] Create Count'},
    color_key: 'green',
    description: {tw: '透過第三方支付發起儲值申請的總次數', en: 'Total number of deposit requests initiated via third-party payment'},
  },
  'dpst_reject_count': {
    name: {tw: '[上分] 拒絕次數', en: '[DPST.] Reject Count'},
    color_key: 'green',
    description: {tw: '儲值申請被網站拒絕的次數，拒絕過多需檢查風控規則', en: 'Number of deposit requests rejected by the site; excessive rejections may require risk control review'},
  },
  'dpst_fail_count': {
    name: {tw: '[上分] 三方失敗次數', en: '[DPST.] 3rd-Party Fail Count'},
    color_key: 'green',
    description: {tw: '第三方支付處理儲值交易失敗的次數，失敗過多可能是三方通道不穩定', en: 'Number of deposit transactions that failed at the third-party provider; excessive failures may indicate channel instability'},
  },
  'dpst_fail_ratio': {
    growth_kind: 'gr_amt',
    name: {tw: '[上分] 三方失敗率', en: '[DPST.] 3rd-Party Fail Ratio'},
    color_key: 'green',
    description: {tw: '三方支付處理儲值交易的失敗比例，用於評估各支付通道的穩定性', en: 'Failure rate of third-party deposit transactions; used to evaluate payment channel stability'},
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'dpst_succ_count': {
    name: {tw: '[上分] 成功次數', en: '[DPST.] Success Count'},
    color_key: 'green',
    description: {tw: '透過第三方支付成功完成儲值的總次數', en: 'Total number of deposits successfully completed via third-party payment'},
  },
  'dpst_minutes_p50': {
    growth_kind: 'gr_amt',
    name: {tw: '[上分] 交易分鐘(p50)', en: '[DPST.] TXN. Minutes(P50)'},
    color_key: 'green',
    description: {tw: '儲值交易處理時間的中位數，50% 的交易在這個時間內完成', en: 'Median deposit processing time; 50% of transactions complete within this time'},
    is_anno_by_total: true,
    ...NF_FRAC_1,
  },
  'dpst_minutes_p90': {
    growth_kind: 'gr_amt',
    name: {tw: '[上分] 交易分鐘(p90)', en: '[DPST.] TXN. Minutes(P90)'},
    color_key: 'green',
    description: {tw: '儲值交易處理時間的第 90 百分位數，90% 的交易在這個時間內完成', en: '90th percentile of deposit processing time; 90% of transactions complete within this time'},
    is_anno_by_total: true,
    ...NF_FRAC_1,
  },
  'dpst_minutes_p99': {
    growth_kind: 'gr_amt',
    name: {tw: '[上分] 交易分鐘(p99)', en: '[DPST.] TXN. Minutes(P99)'},
    color_key: 'green',
    description: {tw: '儲值交易處理時間的第 99 百分位數，代表最慢的 1% 交易需要多久', en: '99th percentile of deposit processing time; indicates how long the slowest 1% of transactions take'},
    is_anno_by_total: true,
    ...NF_FRAC_1,
  },
  'wdrl_create_count': {
    name: {tw: '[下分] 申請次數', en: '[WDRL.] Create Count'},
    color_key: 'purple',
    description: {tw: '透過第三方支付發起提款申請的總次數', en: 'Total number of withdrawal requests initiated via third-party payment'},
  },
  'wdrl_reject_count': {
    name: {tw: '[下分] 拒絕次數', en: '[WDRL.] Reject Count'},
    color_key: 'purple',
    description: {tw: '提款申請被網站拒絕的次數', en: 'Number of withdrawal requests rejected by the site'},
  },
  'wdrl_fail_count': {
    name: {tw: '[下分] 三方失敗次數', en: '[WDRL.] 3rd-Party Fail Count'},
    color_key: 'purple',
    description: {tw: '第三方支付處理提款交易失敗的次數', en: 'Number of withdrawal transactions that failed at the third-party provider'},
  },
  'wdrl_fail_ratio': {
    growth_kind: 'gr_amt',
    name: {tw: '[下分] 三方失敗率', en: '[WDRL.] 3rd-Party Fail Ratio'},
    color_key: 'purple',
    description: {tw: '三方支付處理提款交易的失敗比例，用於評估提款通道的穩定性', en: 'Failure rate of third-party withdrawal transactions; used to evaluate withdrawal channel stability'},
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'wdrl_succ_count': {
    name: {tw: '[下分] 成功次數', en: '[WDRL.] Success Count'},
    color_key: 'purple',
    description: {tw: '透過第三方支付成功完成提款的總次數', en: 'Total number of withdrawals successfully completed via third-party payment'},
  },
  'wdrl_minutes_p50': {
    growth_kind: 'gr_amt',
    name: {tw: '[下分] 交易分鐘(p50)', en: '[WDRL.] TXN. Minutes(P50)'},
    color_key: 'purple',
    description: {tw: '提款交易處理時間的中位數，50% 的交易在這個時間內完成', en: 'Median withdrawal processing time; 50% of transactions complete within this time'},
    is_anno_by_total: true,
    ...NF_FRAC_1,
  },
  'wdrl_minutes_p90': {
    growth_kind: 'gr_amt',
    name: {tw: '[下分] 交易分鐘(p90)', en: '[WDRL.] TXN. Minutes(P90)'},
    color_key: 'purple',
    description: {tw: '提款交易處理時間的第 90 百分位數，90% 的交易在這個時間內完成', en: '90th percentile of withdrawal processing time; 90% of transactions complete within this time'},
    is_anno_by_total: true,
    ...NF_FRAC_1,
  },
  'wdrl_minutes_p99': {
    growth_kind: 'gr_amt',
    name: {tw: '[下分] 交易分鐘(p99)', en: '[WDRL.] TXN. Minutes(P99)'},
    color_key: 'purple',
    description: {tw: '提款交易處理時間的第 99 百分位數，代表最慢的 1% 交易需要多久', en: '99th percentile of withdrawal processing time; indicates how long the slowest 1% of transactions take'},
    is_anno_by_total: true,
    ...NF_FRAC_1,
  },
};

//網路監控
const metrics_network = {
  'full_domain_count': {
    name: {tw: '域名數量', en: 'Domain Count'},
    description: {tw: '統計期間內有流量的不重複域名數量', en: 'Number of unique domains with traffic during the reporting period'},
  },
  'http_req_count': {
    name: {tw: 'HTTP請求次數', en: 'HTTP Request Count'},
    color_key: 'green',
    description: {
      tw: '網站收到的 HTTP 請求總次數，包含所有頁面瀏覽和 API 呼叫，可觀察網站的整體流量',
      en: 'Total HTTP requests received by the site, including all page views and API calls; useful for monitoring overall site traffic',
    },
  },
  'probe_count': {
    name: {tw: '探測次數', en: 'Probe Count'},
    color_key: 'green',
    description: {tw: '對網站進行網路品質探測的總次數', en: 'Total number of network quality probes conducted on the site'},
  },
  'probe_fail_count': {
    name: {tw: '失敗次數', en: 'Failed Count'},
    color_key: 'pink',
    description: {tw: '網路探測失敗的次數，失敗代表玩家可能無法順利連上網站', en: 'Number of failed network probes; failures indicate players may have trouble accessing the site'},
  },
  'probe_fail_ratio': {
    growth_kind: 'gr_amt',
    name: {tw: '失敗率', en: 'Failed Ratio'},
    color_key: 'pink',
    description: {tw: '網路探測失敗的比例，比率越高代表網站可用性越差', en: 'Failure rate of network probes; higher ratios indicate worse site availability'},
    is_anno_by_total: true,
    ...NF_PERCENT_2,
  },
  'latency_ms_pcount': {
    name: {tw: '平均延遲毫秒', en: 'AVG. Latency MS.'},
    color_key: 'green',
    description: {tw: '所有探測的平均回應延遲時間（毫秒），數值越低代表網站回應速度越快', en: 'Average response latency across all probes (in milliseconds); lower values indicate faster site response'},
    is_anno_by_total: true,
  },
  'latency_ms_p50': {
    growth_kind: 'gr_amt',
    name: {tw: '延遲毫秒(p50)', en: 'Latency MS.(p50)'},
    color_key: 'green',
    description: {
      tw: '延遲時間的中位數，50% 的探測在這個時間內完成，代表大多數玩家感受到的回應速度',
      en: 'Median latency; 50% of probes completed within this time, representing the response speed most players experience',
    },
    is_anno_by_total: true,
  },
  'latency_ms_p90': {
    growth_kind: 'gr_amt',
    name: {tw: '延遲毫秒(p90)', en: 'Latency MS.(p90)'},
    color_key: 'green',
    description: {
      tw: '延遲時間的第 90 百分位數，90% 的探測在這個時間內完成，用於觀察較慢的連線體驗',
      en: '90th percentile latency; 90% of probes completed within this time, useful for observing slower connection experiences',
    },
    is_anno_by_total: true,
  },
  'latency_ms_p99': {
    growth_kind: 'gr_amt',
    name: {tw: '延遲毫秒(p99)', en: 'Latency MS.(p99)'},
    color_key: 'green',
    description: {
      tw: '延遲時間的第 99 百分位數，代表最慢的 1% 玩家所經歷的延遲，數值異常高需留意網路瓶頸',
      en: '99th percentile latency; represents the delay experienced by the slowest 1% of players. Unusually high values may indicate network bottlenecks',
    },
    is_anno_by_total: true,
  },
};

//其它
const metrics_other = {
  'levelup_dau': {
    name: {tw: '升級人數', en: 'Level Up Users'},
    color_key: 'blue',
    description: {
      tw: '當天成功升級到更高 VIP 等級的會員人數，可觀察等級制度的流動性',
      en: 'Number of members who upgraded to a higher VIP level on the day; useful for observing level system mobility',
    },
  },
  'levelup_using_days': {
    name: {tw: '升級花費天數', en: 'Level Up Days'},
    color_key: 'light_blue',
    description: {
      tw: '會員從上一個等級升到當前等級平均花了幾天，天數越短代表升級門檻越容易達成',
      en: 'Average number of days members took to upgrade from the previous level; fewer days indicate the upgrade threshold is easier to reach',
    },
  },
  'life_date_max': {
    name: {tw: '最後活躍日', en: 'Last Activity'},
    description: {tw: '會員最近一次有任何活動（登入、遊戲、儲值等）的日期', en: 'Date of the member\'s most recent activity (login, gaming, deposit, etc.)'},
  },
  'life_days': {
    name: {tw: '生命週期', en: 'Life Days'},
    description: {
      tw: '會員從註冊到最後一次活躍之間經過的天數，天數越長代表會員陪伴平台越久',
      en: 'Number of days from registration to last activity; longer periods indicate the member has stayed with the platform longer',
    },
  },
  'site_count': {
    growth_kind: 'gr_amt',
    name: {tw: '網站數量', en: 'Site Count'},
    description: {tw: '統計期間內的網站總數', en: 'Total number of sites during the reporting period'},
  },
};

const metrics_definition = {
  ...metrics_register,
  ...metrics_login,
  ...metrics_game_common,
  ...metrics_trans,
  ...metrics_promo_common,
  ...metrics_game_item,
  ...metrics_promo_binding,
  ...metrics_reg_cvt,
  ...metrics_dpst_reten,
  ...metrics_gm_reten,
  ...metrics_tppp,
  ...metrics_network,
  ...metrics_other,
};

//維度分組（供 FieldGlossary 等 UI 使用：key 順序即顯示順序）
const dimension_groups = [
  {key: 'rpt_date',       label: {tw: '報表日期',   en: 'Report Date'},   icon: 'mdi-calendar',            color: 'blue',   hex: '#42a5f5', def: dimension_rpt_date},
  {key: 'site',           label: {tw: '站台',      en: 'Site'},          icon: 'mdi-web',                 color: 'blue',   hex: '#42a5f5', def: dimension_site},
  {key: 'game_common',    label: {tw: '遊戲',      en: 'Gaming'},        icon: 'mdi-gamepad-variant',     color: 'amber',  hex: '#ffb74d', def: dimension_game_common},
  {key: 'promo_common',   label: {tw: '活動',      en: 'Promotion'},     icon: 'mdi-gift',                color: 'pink',   hex: '#ec407a', def: dimension_promo_common},
  {key: 'promo_binding',  label: {tw: '綁定型活動', en: 'Binding Promo'}, icon: 'mdi-link-variant',        color: 'pink',   hex: '#ec407a', def: dimension_promo_binding},
  {key: 'game_item',      label: {tw: '道具',      en: 'Game Items'},    icon: 'mdi-cards',               color: 'orange', hex: '#ff9800', def: dimension_game_item},
  {key: 'tppp',           label: {tw: '三方',      en: '3rd Party'},     icon: 'mdi-swap-horizontal',     color: 'green',  hex: '#66bb6a', def: dimension_tppp},
  {key: 'network',        label: {tw: '網域',      en: 'Network'},       icon: 'mdi-network',             color: 'cyan',   hex: '#26c6da', def: dimension_network},
  {key: 'agent',          label: {tw: '代理',      en: 'Agent'},         icon: 'mdi-account-tie',         color: 'purple', hex: '#ab47bc', def: dimension_agent},
  {key: 'member_segment', label: {tw: '客群',      en: 'Segment'},       icon: 'mdi-account-group',       color: 'purple', hex: '#ab47bc', def: dimension_member_segment},
  {key: 'member_level',   label: {tw: '會員等級',   en: 'Member Level'},  icon: 'mdi-star-circle',         color: 'purple', hex: '#ab47bc', def: dimension_member_level},
  {key: 'member_single',  label: {tw: '單一會員',   en: 'Member'},        icon: 'mdi-account',             color: 'purple', hex: '#ab47bc', def: dimension_member_single},
];

//指標分組（供 FieldGlossary 等 UI 使用：key 順序即顯示順序）
const metrics_groups = [
  {key: 'register',      label: {tw: '註冊',      en: 'Registration'},     icon: 'mdi-account-plus',        color: 'blue',   hex: '#42a5f5', def: metrics_register},
  {key: 'login',         label: {tw: '登入',      en: 'Login'},            icon: 'mdi-login',               color: 'blue',   hex: '#42a5f5', def: metrics_login},
  {key: 'game_common',   label: {tw: '遊戲',      en: 'Gaming'},           icon: 'mdi-gamepad-variant',     color: 'amber',  hex: '#ffb74d', def: metrics_game_common},
  {key: 'trans',         label: {tw: '交易',      en: 'Transactions'},     icon: 'mdi-cash-multiple',       color: 'teal',   hex: '#26a69a', def: metrics_trans},
  {key: 'promo_common',  label: {tw: '活動',      en: 'Promo'},            icon: 'mdi-gift',                color: 'pink',   hex: '#ec407a', def: metrics_promo_common},
  {key: 'game_item',     label: {tw: '道具',      en: 'Game Items'},       icon: 'mdi-cards',               color: 'orange', hex: '#ff9800', def: metrics_game_item},
  {key: 'promo_binding', label: {tw: '綁定型活動', en: 'Binding Promo'},    icon: 'mdi-link-variant',        color: 'pink',   hex: '#ec407a', def: metrics_promo_binding},
  {key: 'reg_cvt',       label: {tw: '註冊後轉化', en: 'Reg CVT'},          icon: 'mdi-account-arrow-right', color: 'green',  hex: '#66bb6a', def: metrics_reg_cvt},
  {key: 'dpst_reten',    label: {tw: '存款留存',   en: 'DPST. Retention'},  icon: 'mdi-repeat',              color: 'green',  hex: '#66bb6a', def: metrics_dpst_reten},
  {key: 'gm_reten',      label: {tw: '遊戲留存',   en: 'Gaming Retention'}, icon: 'mdi-repeat-variant',      color: 'green',  hex: '#66bb6a', def: metrics_gm_reten},
  {key: 'tppp',          label: {tw: '三方',      en: '3rd-Party'},        icon: 'mdi-swap-horizontal',     color: 'green',  hex: '#66bb6a', def: metrics_tppp},
  {key: 'network',       label: {tw: '網路監控',   en: 'Network Monitor'},  icon: 'mdi-network',             color: 'cyan',   hex: '#26c6da', def: metrics_network},
  {key: 'other',         label: {tw: '其它',      en: 'Others'},           icon: 'mdi-dots-horizontal',     color: 'grey',   hex: '#9e9e9e', def: metrics_other},
];

function get_metric_def(metric_name) {
  if(metrics_definition[metric_name])
    return metrics_definition[metric_name];

  const base_metric_name = metric_name.split('|')[0];
  return metrics_definition[base_metric_name] || {};
}

function build_metric_list(metric_names = []) {
  if(!Array.isArray(metric_names))
    return [];

  return metric_names.map((em_i, idx) => {
    if(em_i == null)
      return null;
    const metric_def = get_metric_def(em_i);
    return {
      metric_field: em_i,
      item_idx: idx,
      item_text: i18n.tfd(em_i),
      ...(metric_def ? {item_options: metric_def} : {}),
    };
  });
}

const fields = {
  ...dimension_definition,
  ...metrics_definition,
};

function calc_prev_value(curr_value, growth_value, growth_kind){
  if(!Number.isFinite(curr_value) || !Number.isFinite(growth_value))
    return null;
  if(growth_kind === 'gr_rate'){
    const denom = 1 + growth_value;
    if(denom === 0)
      return null;
    const prev = curr_value / denom;
    return Number.isFinite(prev) ? prev : null;
  }
  if(growth_kind === 'gr_amt')
    return curr_value - growth_value;
  return null;
}

const GROWTH_RATE_FORMAT = Object.freeze({is_percent: true, fraction_digits: 2});
const GROWTH_KINDS = ['gr_rate', 'gr_amt'];

/**
 * 為單一 metric 建立成長欄位（gr_rate / gr_amt）的存取與顯示工具。
 *
 * 前提：對任一 metric，資料中 `gr_rate` 與 `gr_amt` 不會同時出現 — 因此可由「資料中存在哪個欄位」唯一決定 kind。
 *
 * @param {string} metric_field - 主指標欄位名（如 `apv_bet`），可帶後綴。
 * @param {string[]} available_columns - 資料中實際存在的欄位清單（從 Arquero `columnNames()` 或 `Object.keys(record)` 取得）。
 * @param {object} base_format - 主指標的 number_format；當成長欄位是 `gr_amt`（絕對值）時沿用，`gr_rate` 一律使用 `GROWTH_RATE_FORMAT`。
 * @returns {object|null} 找不到成長欄位時回 null。否則回傳：
 *   - `growth_field` {string} 完整欄位名（如 `apv_bet|gr_rate`），call site 用來從資料取值。
 *   - `growth_label` {string} 已 i18n 的 label（"成長率" / "成長數"）。
 *   - `calc_prev(curr_value, growth_value)` {function} 由現值與成長值反推前期值。
 *   - `get_growth_text(growth_value)` {function} 顯示文字（"↑ 12.34%" / "↓ 5.67"），無資料回 `--.--`。
 *   - `get_growth_color(growth_value)` {function} 對應顏色（綠/紅），無資料回中性灰。
 */
// query_data 系列前端算成長率時，決定某欄位用哪種成長率：
//   量（人數 / 筆數 / 金額）預設 gr_rate；比率 / 分鐘數 / 排名類在指標定義標 growth_kind: 'gr_amt'；
//   不是指標的欄位（維度、buckets）回 null 表示不算
function get_growth_kind(field){
  const def = metrics_definition[field];
  return def ? (def.growth_kind ?? 'gr_rate') : null;
}

function build_growth_helper(metric_field, available_columns, base_format){
  const base_field = metric_field.split('|')[0];
  const growth_kind = GROWTH_KINDS.find(k => available_columns.includes(`${base_field}|${k}`)) ?? null;
  if(!growth_kind)
    return null;
  const growth_format = growth_kind === 'gr_rate' ? GROWTH_RATE_FORMAT : base_format;
  const is_blank = (v) => v === undefined || v === null || !Number.isFinite(v);
  return {
    growth_field: `${base_field}|${growth_kind}`,
    growth_label: i18n.t(`field_desc.${growth_kind}`),
    calc_prev: (curr_value, growth_value) => calc_prev_value(curr_value, growth_value, growth_kind),
    get_growth_text: (growth_value) => {
      if(is_blank(growth_value))
        return '--.--';
      const arrow = growth_value >= 0 ? '↑' : '↓';
      return `${arrow} ${g_number_2_text(Math.abs(growth_value), growth_format)}`;
    },
    get_growth_color: (growth_value) => {
      if(is_blank(growth_value))
        return 'rgb(52, 58, 63)';
      return growth_value >= 0 ? '#76d394' : '#ef5350';
    },
  };
}

export {
  field_prefix,
  field_suffix,
  fields,
  dimension_definition,
  metrics_definition,
  dimension_groups,
  metrics_groups,
  build_metric_list,
  build_growth_helper,
  get_growth_kind,
};
